// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/external-link.js';

import { paths } from '../generated/external-link';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('external-link', Original, paths);
